import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { PageHeader, Tag } from 'antd';

import { pageSectionTitle } from '../util/Style';

import { AgGridReact } from 'ag-grid-react';

const height = window.innerHeight * .74;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
};


const columnDefs = [
    { headerName: 'Branch', field: 'branchName'},
    { headerName: 'Total Due', field: 'totalDue',  type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
];

class BranchDueGrid extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = props.store;
    }

    fetchBranchSummary = () => {
        this.store.fetchBranchSummary();
    }

    countTag = () => {
       
            return (
                <Tag color="#108ee9">Total Due {this.store.grandTotal}</Tag>
            )
        

        if (this.store.isError) {
            return <Tag color="red">...</Tag>
        }
    }

    onSelectionChanged = () => {
        const selectedRows = this.gridRef.current.api.getSelectedRows();

        const branchId = selectedRows[0].branchId;
        const branchName = selectedRows[0].branchName;

        this.store.publishLabDues(branchId,branchName);
        this.store.clearSelectedLab();
    }

    render() {
        const receivables = this.store.branchDues;

        return (
            <PageHeader style={{ paddingTop: 0 }} title={pageSectionTitle(this.props.title)} tags={this.countTag()}>
                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        rowHeight={30}
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={receivables}
                        rowSelection={'single'}
                        columnDefs={columnDefs}
                        onSelectionChanged={this.onSelectionChanged}
                        onGridReady={this.fetchBranchSummary}>
                    </AgGridReact>
                </div>
            </PageHeader>

        )
    }
}

export default observer(BranchDueGrid)
